import { css } from '@emotion/react';
import { Row, Tabs, Typography } from 'antd';
import { useState } from 'react';
import AdviceRecommendSalt from './advice-recommend.salt';
import AdviceRecommendWater from './advice-recommend.water';
import { AdviceRecommendFilter } from '@/components/forms/advice-recommend/adivce-recommend.form';
import AdviceRecommendPhysicalActivity from './advice-recommend.physical-activity';
import AdviceRecommendSugar from './advice-recommend.sugar';
import AdviceRecommendSleep from './advice-recommend.sleep';
import AdviceRecommendEmotion from './advice-recommend.emotion';
import AdviceRecommendDiet from './advice-recommend.diet';

export default function AdviceRecommend() {
  const [activeTab, setActiveTab] = useState('PHYSICAL_ACTIVITY');
  const [filterValue, setFilterValue] = useState<FilterAdviceRecommend>({
    ageRange: ''
  });

  const items = [
    { key: 'PHYSICAL_ACTIVITY', label: 'Hoạt động thể lực' },
    { key: 'SALT', label: 'Muối' },
    { key: 'SUGAR', label: 'Đường' },
    { key: 'SLEEP', label: 'Giấc ngủ' },
    { key: 'WATER', label: 'Uống nước' },
    { key: 'EMOTION', label: 'Cảm xúc' },
    { key: 'DIET', label: 'Ăn uống' }
  ];

  return (
    <div css={rootStyles}>
      {[
        'PHYSICAL_ACTIVITY',
        'SALT',
        'SUGAR',
        'SLEEP',
        'WATER',
        'EMOTION',
        'DIET'
      ].includes(activeTab) && (
        <>
          <Row css={boxStyles} justify='space-between' align='middle'>
            <Typography.Title css={titleStyles} level={5}>
              Quản lý nội dung lời khuyên & khuyến nghị{' '}
            </Typography.Title>
          </Row>

          <Tabs
            css={tabStyle}
            defaultActiveKey='LIST'
            onChange={(key) => setActiveTab(key)}
          >
            {items.map((item) => (
              <Tabs.TabPane tab={item.label} key={item.key} />
            ))}
          </Tabs>
        </>
      )}

      <div css={boxStyles}>
        <AdviceRecommendFilter 
          onChange={setFilterValue} 
          value={filterValue}
          adviceCateCode={activeTab}
        />
      </div>

      <div css={contentStyles}>
        {activeTab === 'PHYSICAL_ACTIVITY' && (
          <AdviceRecommendPhysicalActivity
            key={activeTab}
            filterValue={filterValue}
          />
        )}
        {activeTab === 'SALT' && (
          <AdviceRecommendSalt key={activeTab} filterValue={filterValue} />
        )}
        {activeTab === 'SUGAR' && (
          <AdviceRecommendSugar key={activeTab} filterValue={filterValue} />
        )}
        {activeTab === 'SLEEP' && (
          <AdviceRecommendSleep key={activeTab} filterValue={filterValue} />
        )}
        {activeTab === 'EMOTION' && (
          <AdviceRecommendEmotion key={activeTab} filterValue={filterValue} />
        )}
        {activeTab === 'WATER' && (
          <AdviceRecommendWater key={activeTab} filterValue={filterValue} />
        )}
        {activeTab === 'DIET' && (
          <AdviceRecommendDiet key={activeTab} filterValue={filterValue} />
        )}
      </div>
    </div>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const tabStyle = css`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 6px 8px;
    color: #333;
    border: 1px solid #ccc;
    background-color: #f0f0f0;
  }

  .ant-tabs-tab:not(:first-of-type) {
    margin: 0 0 0 8px !important;
  }

  .ant-tabs-tab-active {
    background-color: var(--blue-dark-color);
    border: 1px solid var(--blue-dark-color);
    .ant-tabs-tab-btn {
      color: #ffffff !important;
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab:hover {
    color: #333 !important;
  }
`;

const contentStyles = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
